import styled from 'styled-components'
import colors from 'configuration/colors'
import FlexAlignCenter from 'components/styled/FlexAlignCenter'
import { Caption1 } from 'components/styled/typography/typography'
import itemHighlight from 'components/styled/itemHighlight'

export const AnnouncementsSidebarContainer = styled.section`
  position: fixed;
  width: 430px;
  left: ${props => (props.shouldDisplay ? '72px' : '-430px')};
  height: 100vh;
  padding-bottom: 20px;
  background-color: ${props => props.theme.announcementsBackground};
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: left 0.35s;
  @media all and (max-width: 1024px) {
    left: ${props => (props.shouldDisplay ? props.isSideNavCollapsed ? '0' : '72px' : '-430px')}
  }
`

export const AnnouncementsSidebarHeader = styled(FlexAlignCenter)`
  justify-content: space-between;
  width: 100%;
  height: 48px;
  padding: 0 28px;
  background: ${props => props.theme.announcementsHeaderBackground};
  border-bottom: ${props => props.theme.courseCardBorder};
`

export const MarkAll = styled(Caption1).attrs({ as: 'button' })`
  text-decoration: underline;
  cursor: pointer;
  border: none;
  background: transparent;
`

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 14px;
  border: 1px solid ${props => props.enabled ? colors.cobalt : colors.rock};
  background: transparent;
  cursor: pointer;

  img {
    padding-top: 2px;
  }

  &:hover {
    background: ${props => props.enabled ? 'rgba(0,112,224,0.15)' : props.theme.chartBackground};
  }
`

export const NotificationAnnouncementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  margin: 0;
`

export const AnnouncementList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 0;
  min-height: calc(100% - 22px);
  margin: 0;
  padding: 0 0 30px;
  overflow-y: scroll;

  /*
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  */
`

export const AnnouncementListItem = styled.div`
  position: relative;
  margin: 0;
  padding: ${props =>
    props.showcased ? '33px 0 33px 28px' : '5px 0 5px 28px'};
  background: ${props =>
    props.isUnread && !props.showcased
      ? 'rgba(253,196,74,0.2)'
      : props.showcased
      ? props => props.theme.cardBackground
      : 'inherit'};
  box-shadow: ${props =>
    props.showcased ? '0 1px 9px 0 rgba(0,0,0,0.15)' : 'none'};
`

export const AnnouncementListItemCard = styled.div`
  height: fit-content;
  width: 363px;
  padding: 16px 20px 16px 14px;
  border: ${props => props.theme.scheduleBorder};
  border-radius: 7px;
  background-color: ${props => props.theme.cardBackground};
  box-sizing: border-box;


  ${itemHighlight}

  .oe-elapsed-time {
    display: inline;
  }

  .draft-js-output {
    div,
    iframe {
      max-width: 100% !important;
    }
  }
`

export const NotificationDotWrapper = styled(FlexAlignCenter)`
  position: absolute;
  right: 10px;
  top: 6px;
  height: 16px;
  cursor: pointer;
`

export const MarkableButton = styled.div`
  right: 10px;
  height: 16px;
  width: 16px;
  border: 0.5px solid ${props => (!props.isRead ? '#F68832' : '#979797')};
  border-radius: 16px;
  background: ${props =>
    !props.isRead ? 'rgba(255, 174, 0, 0.7)' : 'transparent'};
  cursor: ${props =>
    props.isGuardian ? 'not-allowed' : 'pointer'};
  box-sizing: border-box;
  transition: box-shadow 0.2s;
  @media screen and (min-device-width: 1025px) {
    &:hover {
      border: 0.5px solid #f68832;
      background: rgba(255, 174, 0, 0.7);
      box-shadow: 0px 0px 3px 3px ${colors.oeYellow};
    }
  }
`
